<template>
  <div>
    <xlsx-workbook v-if="students.length > 0">
      <xlsx-sheet
        :collection="sheet.data"
        v-for="sheet in activeDownload"
        :key="sheet.name"
        :sheet-name="sheet.name"
      />
      <xlsx-download
        v-if="active"
        :filename="
          `${active.school} - ${active.currentSubject.toLowerCase()} - ${
            active.thread
          } - Grade ${active.grade} - ${fileName}.xls`
        "
      >
        <div class="section-btn rb shadow dwnld active white pointer">
          Download Spreadsheet<b-icon :icon="icon" custom-size="default" />
        </div>
      </xlsx-download>
    </xlsx-workbook>
    <div
      v-else
      class="white section-btn rb shadow dwnld"
      style="cursor: not-allowed; border: 2px solid white"
    >
      Download Spreadsheet<b-icon :icon="icon" custom-size="default" />
    </div>
  </div>
</template>

<script>
import { XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx";
import { mapState } from "vuex";

export default {
  name: "CSVDownload",
  props: {
    students: {
      type: Array
    },
    Chart: {
      type: Number
    },
    icon: {
      type: String,
      default: "arrow-top-right-thick"
    }
  },
  components: {
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload
  },
  computed: {
    ...mapState({
      active: state => state.globalStore.activeFilterParams,
      threadId: state => state.globalStore.activeFilterParams.threadId,
      thread: state => state.globalStore.activeFilterParams.thread,
      assessmentType: state =>
        state.globalStore.activeFilterParams.assessmentType,
      normal: state => state.globalStore.filterLists.threads.value.normal,
      matric: state => state.globalStore.filterLists.threads.value.matric,
      reflectiveData: state => state.globalStore.reflectiveData,
      projectName: state => state.globalStore.activeFilterParams.projectName,
      currentSubject: state =>
        state.globalStore.activeFilterParams.currentSubject
    }),
    filteredLearnersByGrade() {
      if (this.reflectiveData.length > 0) {
        if (this.active.school) {
          return this.reflectiveData.filter(
            user =>
              user.grade == this.active.grade &&
              user.project == this.active.project &&
              user.school == this.active.school
          );
        } else {
          return this.reflectiveData.filter(
            user =>
              user.grade == this.active.grade &&
              user.project == this.active.project
          );
        }
      }
      return [];
    },
    activeThreads() {
      if (this.active.isMatricAssessment) {
        return this.matric;
      }
      return this.normal;
    },
    activeDownload() {
      if (this.Chart === 0) {
        return this.progressFile();
      } else if (this.Chart === 1) {
        return this.resultsFile();
      } else if (this.Chart === 2) {
        return this.catchupFile();
      } else if (this.Chart === 3) {
        return this.improvementsFile();
      }
      return this.resultsFile();
    },
    fileName() {
      if (this.Chart === 0) {
        return "Progress";
      } else if (this.Chart === 1) {
        return "Results";
      } else if (this.Chart === 2) {
        return "Catchup";
      } else if (this.Chart === 3) {
        return "Improvements";
      }
      return "Results";
    }
  },
  methods: {
    progressFile() {
      let progress = [];
      this.filteredLearnersByGrade.forEach(user => {
        // map for each thread
        let allThreads = {};
        this.activeThreads.forEach((thread, index) => {
          if (user.assessmentStates) {
            let currentThreadProgress =
            user.assessmentStates[0].threads[index] ? user.assessmentStates[0].threads[index].progress : 0;
            allThreads[thread] = currentThreadProgress;
          } else {
            allThreads[thread] = 0;
          }
        });
        let headersTemplate = {
          Name: user.firstName,
          Surname: user.lastName,
          Email: user.email,
          Project: this.projectName,
          School: user.school,
          Subject: this.currentSubject.toLowerCase(),
          Grade: user.grade,
          Class: user.class ? user.class : "--",
          ...allThreads
        };
        progress.push(headersTemplate);
      });

      return [
        {
          name: this.limitSheetName(`Progress`),
          data: progress
        }
      ];
    },
    resultsFile() {
      let results = [];
      this.filteredLearnersByGrade.forEach(user => {
        // map for each thread
        let allThreads = {};
        this.activeThreads.forEach((thread, index) => {
          if (user.assessmentStates) {
            let currentThreadFeedback = user.assessmentStates[0].feedback.find(
              currentThread => currentThread.threadId == index + 1
            );
            if (currentThreadFeedback) {
              allThreads[thread] = currentThreadFeedback.gradeMastered;
            } else {
              allThreads[thread] = "--";
            }
          } else {
            allThreads[thread] = "Not finished yet";
          }
        });
        let headersTemplate = {
          Name: user.firstName,
          Surname: user.lastName,
          Email: user.email,
          Project: this.projectName,
          School: user.school,
          Subject: this.currentSubject.toLowerCase(),
          Grade: user.grade,
          Class: user.class ? user.class : "--",
          ...allThreads
        };
        results.push(headersTemplate);
      });

      return [
        {
          name: this.limitSheetName(`Results`),
          data: results
        }
      ];
    },
    improvementsFile() {
      let progress = [];
      this.filteredLearnersByGrade.forEach(user => {
        if (
          user.improvement &&
          user.improvement[this.currentSubject] &&
          user.improvement[this.currentSubject][this.threadId + 1] &&
          user.improvement[this.currentSubject][this.threadId + 1].length > 0
        ) {
          let reassessArr =
            user.improvement[this.currentSubject][this.threadId + 1].length;
          let headersTemplate = {
            Name: user.firstName,
            Surname: user.lastName,
            Email: user.email,
            Project: this.projectName,
            School: user.school,
            Subject: this.currentSubject.toLowerCase(),
            Thread: this.thread,
            Grade: user.grade,
            Class: user.class ? user.class : "--",
            "Initial Results":
              user.improvement[this.currentSubject][this.threadId + 1][0]
                .gradeMastered,
            "latest Mastered Grade":
              user.improvement[this.currentSubject][this.threadId + 1][
                reassessArr - 1
              ].gradeMastered,
            "Reassessments Done": reassessArr - 1
          };
          progress.push(headersTemplate);
        } else {
          let headersTemplate = {
            Name: user.firstName,
            Surname: user.lastName,
            Email: user.email,
            Project: this.projectName,
            School: user.school,
            Subject: this.currentSubject.toLowerCase(),
            Thread: this.thread,
            Grade: user.grade,
            Class: user.class ? user.class : "--",
            "Initial Results": "--",
            "latest Mastered Grade": "--",
            "Reassessments Done": "--"
          };
          progress.push(headersTemplate);
        }
      });

      return [
        {
          name: this.limitSheetName(`Improvements`),
          data: progress
        }
      ];
    },
    catchupFile() {
      let catchup = [];
      this.filteredLearnersByGrade.forEach(user => {
        let mastered = "--";
        let done = "--";
        let notDone = "--";
        let feedbackArray = user.assessmentStates[0].feedback.find(
          thread => thread.threadId === this.threadId + 1
        );
        if (feedbackArray) {
          mastered = this.mastered(feedbackArray);
          done = this.done(user, feedbackArray);
          notDone = feedbackArray.conceptMastery.length - mastered - done;
        }
        let headersTemplate = {
          Name: user.firstName,
          Surname: user.lastName,
          Email: user.email,
          Project: this.projectName,
          School: user.school,
          Subject: this.currentSubject.toLowerCase(),
          Thread: this.thread,
          Grade: user.grade,
          Class: user.class ? user.class : "--",
          "Mastered Concepts": mastered,
          "Concepts Done": done,
          "Concepts to go": notDone
        };

        catchup.push(headersTemplate);
      });

      return [
        {
          name: this.limitSheetName(`Catchup Progress`),
          data: catchup
        }
      ];
    },
    mastered(arr) {
      return arr.conceptMastery.filter(concept => concept === 3).length;
    },
    done(user, feedback) {
      let unmastered = [];
      feedback.conceptMastery.forEach((concept, index) => {
        if (concept !== 3) unmastered.push(index);
      });
      let currentStage = user.catchupStates[0].threads[this.threadId].stage
        ? user.catchupStates[0].threads[this.threadId].stage.concept
        : 0;
      if (currentStage == 0) {
        return 0;
      } else {
        let conceptPosition = unmastered.findIndex(
          concept => concept == currentStage - 1
        );
        if (conceptPosition == -1) {
          return unmastered.length;
        } else {
          return conceptPosition;
        }
      }
    },
    limitSheetName(sheetName) {
      if (sheetName.length > 31) {
        sheetName = sheetName.replaceAll(" ", "");
        sheetName = sheetName.substring(0, 31);
      }
      return sheetName;
    }
  }
};
</script>
